import action from '../../../abstract/action.js';

export default action({
  label: 'Przekaż dalej',
  icon: 'CopyIcon',
  main: () => true,
  handle: async ({ $router, item: { id } }) => await $router.push({ name: 'mailing-stepper-forward', params: { id } }),
});